import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import axios from "axios";
import VueExpandableImage from 'vue-expandable-image'
Vue.use(VueExpandableImage)

Vue.config.productionTip = false
import Swal from 'sweetalert2';
Vue.prototype.$swal = Swal;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;
axios.defaults.withXSRFToken = true;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';

axios.interceptors.request.use(function (config) {
  store.commit('setLoading', true);
  return config;
}, function (error) {
  store.commit('setLoading', false);
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
  store.commit('setLoading', false);
  return response;
}, function (error) {
  store.commit('setLoading', false);
  return Promise.reject(error);
});

import Role from './helpers/Role';

store.dispatch('auth/me').then(() => {
  if (store.getters['auth/authenticated']) {
    if (router.currentRoute.path === '/login') {
      const user = store.getters['auth/user'];
      let target = '/schools';
      if (user && user.role) {
        if (user.role.name === Role.Teacher) {
          target = '/class';
        } else if (user.role.name === Role.SchoolAdmin) {
          target = '/school/';
        }
      }
      router.replace(target).catch(() => {});
    }
  }

  new Vue({
    vuetify,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

